import { ready } from '@felicity/vision';
import '@felicity/vision/form';
import { Monitor } from '@felicity/captcha';
import './libraries/fontawesome.mjs';
import './components/HeroText.mjs';
import './components/NewsGlide.mjs';
import initNavbar from './components/Navbar.mjs';
import initLocationMap from './components/LocationMap.mjs';
import '../styles/site.less';

// Background images are only loaded once their element nears the viewport
const backgroundObserver = new IntersectionObserver((entries) => {
  entries
    .filter((entry) => entry.isIntersecting)
    .forEach((entry) => {
      entry.target.style.backgroundImage = `url(${entry.target.dataset.bgSrc})`; // eslint-disable-line no-param-reassign
      backgroundObserver.unobserve(entry.target);
    });
}, { rootMargin: '200px' });

ready(() => {
  document.querySelectorAll('[data-bg-src]').forEach((el) => {
    backgroundObserver.observe(el);
  });
});

// Reveals an element once a tenth of it is in view, which an element taller than the viewport
// reaches too
const observer = new IntersectionObserver((entries) => {
  entries
    .filter((entry) => entry.isIntersecting)
    .forEach((entry) => {
      entry.target.classList.remove('animatable');
      entry.target.classList.add('animated');
      observer.unobserve(entry.target);
    });
}, { threshold: [0.1] });

document.querySelectorAll('.animatable')
  .forEach((animatable) => {
    observer.observe(animatable);
  });

initNavbar();
initLocationMap();

ready(() => {
  Monitor.start();
});
